import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss"; // Importing SASS module
import MessageBox from "reusableComponents/MessageBox";

const ValidatedInput = React.forwardRef(
  (
    {
      icon,
      type,
      value,
      error,
      name,
      placeholder,
      handleChange,
      handleBlur,
      handleFocus,
      autoComplete,
      label,
      required = false,
      showRequiredText = false,
      labelAbove = false,
      disabled = false,
    },
    ref
  ) => {
    const [t] = useTranslation("global");

    return (
      <div
        className={`${styles.inputWithIcon__wrapper} ${
          labelAbove ? styles.labelAbove : styles.labelInline
        } ${disabled ? styles.disabledWrapper : ""}`} // Add disabledWrapper class if disabled
      >
        {label && (
          <p className={styles.inputLabel}>
            {label}
            {required ? (
              <span
                className={styles.requiredIndicator}
                style={{ fontSize: showRequiredText ? "inherit" : "18px" }}
              >
                {showRequiredText
                  ? ` (${t("provide.step2.pictures.required")} *)`
                  : `(*)`}
              </span>
            ) : (
              <span className={styles.requiredIndicator}></span>
            )}
          </p>
        )}
        <div className={styles.inputAndErrWrapper}>
          <div className={styles.inputWithIcon}>
            {icon && (
              <span
                className={styles.inputWithIcon__icon}
                style={{ backgroundImage: `url(${icon})` }}
              ></span>
            )}
            <input
              ref={ref}
              name={name}
              className={`${styles.inputWithIcon__input} ${
                !icon ? styles.noIcon : ""
              } ${disabled ? styles.disabledInput : ""}`} // Add disabledInput class
              placeholder={t(placeholder)}
              onChange={handleChange}
              onBlur={handleBlur}
              onFocus={handleFocus}
              type={type}
              value={value}
              autoComplete={autoComplete}
              disabled={disabled} // Add disabled attribute to input
            />
          </div>
          {error && <MessageBox type="error" message={error} />}
        </div>
      </div>
    );
  }
);

export default ValidatedInput;
